import { FC } from "react";

import {
	Avatar,
	Box,
	Card,
	CardContent,
	Chip,
	Grid,
	Typography,
	useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { SATOSContentRender } from "@/components/Application/SATOSContentRender";
import { useTime } from "@/components/Application/TimeContext";
import { tokens } from "@/components/Application/theme";
import { StepLogLineStatus } from "@/components/Procedures/Checklist/Step/StepLogLineStatus";
import { stringAvatar } from "@/components/Procedures/Checklist/utils/Helpers";
import { IStepLogLine } from "@/components/Procedures/Checklist/utils/Types";

dayjs.extend(utc);

export const StepLogLine: FC<IStepLogLine> = (props) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const { timezone } = useTime();
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "flex-start",
				position: "relative",
				mb: 4,
			}}
		>
			{/* Vertical Line */}
			<Box
				sx={{
					width: 2,
					bgcolor: colors.primary[900],
					position: "absolute",
					left: 20,
					top: 0,
					bottom: 0,
				}}
			/>

			{/* Marker and Date */}
			<Box
				sx={{
					borderRadius: "50%",
					mr: 1,
					alignSelf: "flex-start",
					mt: 0.5,
					ml: 4,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Typography variant="caption" sx={{ color: "text.secondary", mb: 1 }}>
					{dayjs.utc(props.logLine.Date).tz(timezone).format("DD/MM/YY")}
				</Typography>
				<Typography variant="caption" sx={{ color: "text.secondary", mb: 1 }}>
					{dayjs.utc(props.logLine.Date).tz(timezone).format("HH:mm:ss")}
				</Typography>
			</Box>

			{/* Card for the comment */}
			<Box sx={{ minWidth: "70%", pl: 6, mt: -1 }}>
				<Card variant="outlined" sx={{ padding: "8px 8px 8px 16px" }}>
					<CardContent sx={{ padding: 0 }}>
						<Grid container spacing={2} alignItems="center">
							<Grid item>
								<Avatar
									{...stringAvatar(props.logLine.UserName)}
									alt={props.logLine.UserName}
								/>
							</Grid>
							<Grid item xs>
								<Typography variant="subtitle1" sx={{ fontWeight: "550" }}>
									{props.logLine.UserName}
								</Typography>
								<Typography variant="body1">
									<SATOSContentRender content={props.logLine.Value} />
								</Typography>
								<Chip
									icon={<StepLogLineStatus {...props} />}
									label={props.logLine.ArchiveType}
									variant="outlined"
									size="small"
									sx={{ mt: 1 }}
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Box>
		</Box>
	);
};
